import React from "react";
import CoreTeam from "./CoreTeam";
import AdvisoryBoard from "./AdvisoryBoard";
import DomainExperts from "./DomainExperts";

const TeamSection = () => {
  return (
    <div id="People" className="container mx-auto mt-11 px-4">
      <div className="xl:col-start-3 col-12 lg:col-span-8 xl:col-span-5 mb-12">
        <div className="grid grid-cols-1 gap-12">
          <CoreTeam />
        </div>
      </div>
      {/* <div className="grid grid-col-12 lg:grid-cols-2 gap-12 sm:w-fit mx-auto"> */}
      <div className="flex flex-col gap-12">
        {/* <div className="col-12 lg:col-span-8 xl:col-span-12"> */}
        {/* <div className="grid grid-cols-1 gap-12"> */}
        {/* <AdvisoryBoard /> */}
        {/* </div> */}
        {/* </div> */}
        {/* <div className="col-12 lg:col-span-8 xl:col-span-12"> */}
        {/* <div className="grid grid-cols-1 gap-12"> */}
        <DomainExperts />
        {/* </div> */}
        {/* </div> */}
      </div>
    </div>
  );
};

export default TeamSection;
